import { useState, useEffect } from 'react';

const useGeolocation = () => {
  const [location, setLocation] = useState<GeolocationPosition>();
  const [error, setError] = useState<string>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!navigator.geolocation) {
      setError('Geolocation is not supported by your browser.');
      setLoading(false);
      return;
    }

    const successHandler = (position: GeolocationPosition) => {
      setLocation(position);
      setLoading(false);
    };

    const errorHandler = (geoError: GeolocationPositionError) => {
      setError(geoError.message);
      setLoading(false);
    };

    setLoading(true);
    navigator.geolocation.getCurrentPosition(successHandler, errorHandler, {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    });
  }, []);

  return { location, error, loading };
};

export default useGeolocation;
